import { render, staticRenderFns } from "./wheel-type-popover.vue?vue&type=template&id=617acab4&scoped=true"
import script from "./wheel-type-popover.vue?vue&type=script&lang=js"
export * from "./wheel-type-popover.vue?vue&type=script&lang=js"
import style0 from "./wheel-type-popover.vue?vue&type=style&index=0&id=617acab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617acab4",
  null
  
)

export default component.exports